import { Col, Form, Row, Select } from "antd";
import React, { useMemo, useState } from "react";
import {
  maScaleOptions,
  mmtScaleOptions,
  vcgScaleOptions,
} from "../../../../Options/physioOptions";
import upperRightLimb from "../../../../../../assets/images/scalesImages/upperRightLimb.svg";
import upperLeftLimb from "../../../../../../assets/images/scalesImages/upperLeftLimb.svg";
import lowerRightLimb from "../../../../../../assets/images/scalesImages/lowerRightLimb.svg";
import lowerLeftLimb from "../../../../../../assets/images/scalesImages/lowerLeftLimb.svg";
import ScalesInfoViewer from "../ScalesInfoViewer";
import MASImg from "../../../../../../assets/scalesInfo/MASInfo.png";
import MMTImg from "../../../../../../assets/scalesInfo/MMTInfo.png";
import VCGImg from "../../../../../../assets/scalesInfo/VCGInfo.png";
import "./MMTScaleItems.css";

const LIMB_FIELDS = [
  {
    label: "Upper Left Limb",
    name: "upper_left_limb",
    image: upperLeftLimb,
    side: "left",
  },
  {
    label: "Upper Right Limb",
    name: "upper_right_limb",
    image: upperRightLimb,
    side: "right",
  },
  {
    label: "Lower Left Limb",
    name: "lower_left_limb",
    image: lowerLeftLimb,
    side: "left",
  },
  {
    label: "Lower Right Limb",
    name: "lower_right_limb",
    image: lowerRightLimb,
    side: "right",
  },
];

const optionLabel = (label) => (
  <div className="mmt-option-label">{label}</div>
);

const MMTScaleItems = ({ scaleType, initial = false }) => {
  const [openInfo, setOpenInfo] = useState(false);

  const options = useMemo(() => {
    switch (scaleType) {
      case "mas":
        return maScaleOptions || [];
      case "mmt":
        return mmtScaleOptions || [];
      case "vcg":
        return vcgScaleOptions || [];
      default:
        return [];
    }
  }, [scaleType]);

  const selectOptions = useMemo(
    () =>
      options.map((o) => ({
        label: optionLabel(o.label),
        value: o.value,
        title: o.label,
      })),
    [options]
  );

  const scaleInfo = {
    type: "image",
    url: scaleType === "mas" ? MASImg : scaleType === "mmt" ? MMTImg : VCGImg,
  };

  return (
    <div
      className={`op-forms mmt-scale-items mmt-scale-items--${
        scaleType || "default"
      }`}
    >
      <Row gutter={[12, 24]} justify="center">
        {LIMB_FIELDS.map((field) => (
          <Col key={field.name} xs={24} sm={24} md={10} lg={10}>
            <Form.Item
              className="mmt-form-item"
              label={field.label}
              layout="vertical"
            >
              <div
                className={`mmt-select-bg mmt-select-bg--${field.side}`}
                style={{ backgroundImage: `url(${field.image})` }}
              >
                <Form.Item
                  name={initial ? [scaleType, field.name] : field.name}
                  noStyle
                >
                  <Select
                    style={{ width: "100%", height: "100%" }}
                    options={selectOptions}
                    placeholder="Select score"
                    optionLabelProp="title"
                    popupClassName="mmt-scale-items-dropdown"
                    className="no-bg mmt-select-overlay"
                    getPopupContainer={() => document.body}
                  />
                </Form.Item>
              </div>
            </Form.Item>
          </Col>
        ))}
      </Row>

      {openInfo && (
        <ScalesInfoViewer
          data={scaleInfo}
          open={openInfo}
          setOpen={setOpenInfo}
        />
      )}
    </div>
  );
};

export default MMTScaleItems;
